import PaginatedItems from "../Component/PaginatedItems";
import RowSelect from "../Component/RowSelect";
import React, { useState } from "react";
import { IoFilterOutline } from "react-icons/io5";
import axios from "axios";

import { Empty, Spin } from "antd";
import { Menu, Dropdown } from "antd";
import { BASE_URL } from "../Function/Base";
import { Skeleton } from "antd";
import {  useNavigate } from "react-router-dom";

import { LoadingOutlined} from "@ant-design/icons";
import { useAuth } from "../Function/AuthProvider";
import RightBar from "../Component/RightBar";

function Table(props) {
  const navigate = useNavigate();
  
  const [searchQuery, setSearchQuery] = useState("");

  const auth = useAuth();

  const handleRowsPerPageChange = (value, Page) => {
    console.log(value);
    auth?.SetAllcampusformData({
      ...auth.formDataALLcampus,
      page: Page,
      resultsPerPage: value,
    });
  };

  const handleClick = (id, key) => {
    if (key === "publish") {
      axios
        .post(`${BASE_URL}/api/publish-campus?campusID=${id}`, {
          campusID: id,
        })
        .then(function (response) {
          // handle success

          if (response.data?.status === 200) {
            props?.openMessage(response.data?.message, "success", 1);
            props?.GetAllCampus()
            auth.GetSuperDashi();
          } else {
            props?.openMessage(response.data?.message, "error", 1);
          }
        })
        .catch(function (error) {
          // handle error
          props?.openMessage(error.response.data.message, "error", 1);
        })
        .finally(function () {
          // always executed
        });
    } else if (key === "unpublish") {
      axios
        .post(`${BASE_URL}/api/unpublish-campus-page?campusID=${id}`)
        .then(function (response) {
          // handle success

          if (response.data?.status === 200) {
            props?.openMessage(response.data?.message, "success", 1);
            props?.GetAllCampus()
            auth.GetSuperDashi()
          } else {
            props?.openMessage(response.data?.message, "error", 1);
          }
        })
        .catch(function (error) {
          props?.openMessage(error.response.data.message, "error", 1);
        })
        .finally(function () {
          // always executed
        });
    } else if (key === "Delete") {
      axios
        .post(`${BASE_URL}/api/block-campus?campusID=${id}`)
        .then(function (response) {
          // handle success

          if (response.data?.status === 200) {
            props?.openMessage(response.data?.message, "success", 1);
            props?.GetAllCampus()
           auth.GetSuperDashi()
          } else {
            props?.openMessage(response.data?.message, "error", 1);
          }
        })
        .catch(function (error) {
          // handle error

          props?.openMessage(error.response.data.message, "error", 1);
        })
        .finally(function () {
          // always executed
        });
    } else if (key === "Block") {
      axios
        .post(`${BASE_URL}/api/block-campus?campusID=${id}`)
        .then(function (response) {
          // handle success

          if (response.data?.status === 200) {
            props?.openMessage(response.data?.message, "success", 1);
            props?.GetAllCampus()
            auth?.GetSuperDashi()
          } else {
            props?.openMessage(response.data?.message, "error", 1);
          }
        })
        .catch(function (error) {
          // handle error

          props?.openMessage(error.response.data.message, "error", 1);
        })
        .finally(function () {
          // always executed
        });
    } else if (key === "unBlock") {
      axios
        .post(`${BASE_URL}/api/unblock-campus?campusID=${id}`)
        .then(function (response) {
          // handle success

          if (response.data?.status === 200) {
            props?.openMessage(response.data?.message, "success", 1);
            
            props?.GetAllCampus();
            auth?.GetSuperDashi()
          } else {
            props?.openMessage(response.data?.message, "error", 1);
          }
        })
        .catch(function (error) {
          // handle error

          props?.openMessage(error.response.data.message, "error", 1);
        })
        .finally(function () {
          // always executed
        });
    } else if (key === "Decline") {
      axios
        .post(`${BASE_URL}/api/decline-publish-request?campusID=${id}`)
        .then(function (response) {
          // handle success

          if (response.data?.status === 200) {
            props?.openMessage(response.data?.message, "success", 1);
            auth.GetSuperDashi()
            props.GetAllCampus()
          } else {
            props?.openMessage(response.data?.message, "error", 1);
          }
        })
        .catch(function (error) {
          // handle error

          props?.openMessage(error.response.data.message, "error", 1);
        })
        .finally(function () {
          // always executed
        });
    } else if (key === "Accept") {
      axios
        .post(`${BASE_URL}/api/accept-publish-request?campusID=${id}`)
        .then(function (response) {
          // handle success

          if (response.data?.status === 200) {
            props?.openMessage(response.data?.message, "success", 1);
            auth?.GetSuperDashi()
          } else {
            props?.openMessage(response.data?.message, "error", 1);
          }
        })
        .catch(function (error) {
          // handle error

          props?.openMessage(error.response.data.message, "error", 1);
        })
        .finally(function () {
          // always executed
        });
    } else if (key === "View") {
      const url = `/Demo/${id}`;
      window.open(url, "_blank");
    } else if (key === "Edit") {
      axios
        .post(`${BASE_URL}/api/view-campus-demo?campusID=${id}`)
        .then((res) => {
          const data = res.data;

          if (res.data && res.data?.status === "200") {
            navigate("/newPage", {
              state: { campusID: id, page: data, ROUTE: "update" },
            });
          } else {
          }
        })
        .catch((error) => {});
    }
  };

  function menu(id, campusStatus) {
    return (
      <Menu>
        {props.off === "DA" ? (
          <>
            {campusStatus !== "in Trash" ? (
              <>
                <Menu.Item
                  onClick={() =>
                    handleClick(
                      id,
                      campusStatus === "Published" ? "unpublish" : "publish"
                    )
                  }
                  key={`${
                    campusStatus === "Published" ? "Unpublish" : "publish"
                  }`}
                >
                  {" "}
                  {campusStatus === "Published" ? "Unpublish" : "publish"}
                </Menu.Item>
                <Menu.Item onClick={() => handleClick(id, "View")} key="View">
                  View Page
                </Menu.Item>
                <Menu.Item onClick={() => handleClick(id, "Edit")} key="Edit">
                  Edit Page
                </Menu.Item>
                <Menu.Item
                  onClick={() => handleClick(id, "Block")}
                  key={"Block"}
                >
                  Move to Trash
                </Menu.Item>
              </>
            ) : (
              <>
                <Menu.Item
                  onClick={() =>
                    handleClick(
                      id,
                      campusStatus === "in Trash" ? "unBlock" : "Block"
                    )
                  }
                  key={`${campusStatus === "in Trash" ? "unBlock" : "Block"}`}
                >
                  {campusStatus === "in Trash" ? "Restore" : "Move to Trash"}
                </Menu.Item>
              </>
            )}
          </>
        ) : (
          <>
            <Menu.Item onClick={() => handleClick(id, "Decline")} key="Decline">
              Decline-Request
            </Menu.Item>
            <Menu.Item onClick={() => handleClick(id, "Accept")} key="Accept">
              {" "}
              Accept-Request
            </Menu.Item>
            <Menu.Item onClick={() => handleClick(id, "View")} key="View">
              View Page
            </Menu.Item>
          </>
        )}
      </Menu>
    );
  }

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 16,
        color: "#AF20F2",
      }}
      spin
    />
  );

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      // Perform search
      props?.SetAllcampusformData({
        ...props?.formData,
        searchKey: searchQuery,
      });
    }
  };

  function searchHandle() {
    props?.SetAllcampusformData({ ...props?.formData, searchKey: searchQuery });
  }
const [close,setClose]=useState(false)
  return (
    <div>
      <div className=" flex flex-col justify-center gap-8     h-full daark:bg-black dark:text-white ">
        <div className="   bg-white w-full m-2 md:w-[95%]  border border-solid dark:bg-black dark:text-white mt-8  ">
          <div className="flex flex-row justify-between items-center h-[48px]  md:w-full  md:mr-[41px]">
            <div className="flex gap-4 items-center dark:bg-black dark:text-white ">
            <div>
              {close&&
<RightBar close={()=>setClose(!close)} >
<div className="flex flex-col gap-4">
                <label className="flex gap-2">
                  <input
                    type="checkbox"
                    name="All"
                    value="all"
                    placeholder="All"
                    onChange={(e)=>props.SetAllcampusformData({ ...props.formData, campusStatus_filter:e.target.value})}
                  />
                  <p>All</p>
                </label>
                <label className="flex gap-2">
                  <input type="checkbox" name="Published" value="Published"
                                      onChange={(e)=>props.SetAllcampusformData({ ...props.formData, campusStatus_filter:e.target.value})}
                  />
                  <p>Published</p>
                </label>
                <label className="flex gap-2">
                  <input
                    type="checkbox"
                    name="Unpublished"
                    value="Unpublished"
                    onChange={(e)=>props.SetAllcampusformData({ ...props.formData, campusStatus_filter:e.target.value})}
                  />
                  <p>Unpublished</p>
                </label>
                <label className="flex gap-2">
                  <input type="checkbox" name="in Trash" value="in Trash" 
                                      onChange={(e)=>props.SetAllcampusformData({ ...props.formData, campusStatus_filter:e.target.value})}
                  />
                  <p>in Trash</p>
                </label>
                <label className="flex gap-2">
                  <input
                    type="checkbox"
                    name="with out in Trash"
                    value="with out in trash"
                    onChange={(e)=>props.SetAllcampusformData({ ...props.formData, campusStatus_filter:e.target.value})}
                  />
                  <p>with out in Trash</p>
                </label>
              </div>
  </RightBar>
  }
             <div onClick={()=>setClose(!close)} className="flex gap-2 pl-2">
              <p>Filter</p>
              <IoFilterOutline size={20} />
             </div>
             
            </div>
              {/* <select
                className="md:ml-[16px]  dark:bg-black dark:text-white text-sm md:text-md "
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value="All" className="text-sm md:text-md">
                  All
                </option>
                <option value="Published" className="text-sm text-md">
                  Published
                </option>
                <option value="Unpublished" className="text-sm text-md">
                  Unpublished
                </option>
                <option value="in Trash" className="text-sm text-md">
                  in Trash
                </option>
                <option value="notTrash" className="text-sm text-md">
                  with out in Trash
                </option>
              </select> */}
              {/* <p className={`rounded-md px-2 py-1 ${props?.hidden}   ${showintrash?'text-green-500 bg-green-100':'text-red-500 bg-red-100'}`} onClick={()=>setIntrash(!showintrash)}>show Trash {showintrash&&<CheckCircleOutlined twoToneColor="#52c41a" />}</p>
               */}
              <div className="flex">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className=" md:w-[500px] h-[30px]  p-3 dark:bg-black dark:hover:bg-white dark:rounded-md dark:text-black bg-white hover:bg-transparent active:bg-transparent"
                />
                {searchQuery && (
                  <svg
                    onClick={() => searchHandle()}
                    className="dark:text-white hidden md:block"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14 10.0008C12.9391 10.0008 11.9217 10.4222 11.1716 11.1723C10.4214 11.9225 10 12.9399 10 14.0008C10 15.0616 10.4214 16.079 11.1716 16.8292C11.9217 17.5793 12.9391 18.0008 14 18.0008C15.0609 18.0008 16.0783 17.5793 16.8284 16.8292C17.5786 16.079 18 15.0616 18 14.0008C18 12.9399 17.5786 11.9225 16.8284 11.1723C16.0783 10.4222 15.0609 10.0008 14 10.0008ZM8 14.0008C7.99988 13.0565 8.22264 12.1255 8.65017 11.2835C9.0777 10.4415 9.69792 9.71236 10.4604 9.15529C11.2229 8.59822 12.1061 8.22898 13.0381 8.0776C13.9702 7.92622 14.9249 7.99698 15.8245 8.28412C16.724 8.57126 17.5432 9.06667 18.2152 9.73006C18.8872 10.3935 19.3931 11.2061 19.6919 12.1019C19.9906 12.9977 20.0737 13.9514 19.9343 14.8853C19.795 15.8193 19.4372 16.7072 18.89 17.4768L23.707 22.2938C23.8892 22.4824 23.99 22.735 23.9877 22.9972C23.9854 23.2594 23.8802 23.5102 23.6948 23.6956C23.5094 23.881 23.2586 23.9862 22.9964 23.9884C22.7342 23.9907 22.4816 23.8899 22.293 23.7078L17.477 18.8918C16.5794 19.53 15.5233 19.9089 14.4247 19.9869C13.326 20.0648 12.2271 19.8389 11.2483 19.3337C10.2695 18.8286 9.44869 18.0638 8.87572 17.1231C8.30276 16.1824 7.99979 15.1022 8 14.0008Z"
                      fill="#48535B"
                    />
                  </svg>
                )}
              </div>
            </div>
          </div>
          {props?.formData?.Loading !== "undefined" &&
          props?.formData?.Loading === true ? (
            <Skeleton active />
          ) : props?.invited?.length > 0 ? (
            <table key={props?.pageinationComponent} className="w-full">
              <thead className="border border-t-solide  h-[48px] hover:bg-gray-100   ">
                <tr>
                  <td className="">
                    <div className=" gap-2  flex  items-center">
                      <p className="text-[#6E7C87] text-[14px]">
                        {props?.table?.ID}
                      </p>
                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            rollNo: 1,
                            rollNoLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 10 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.292787 5.70679C0.105316 5.51926 0 5.26495 0 4.99979C0 4.73462 0.105316 4.48031 0.292787 4.29279L4.29279 0.292786C4.48031 0.105315 4.73462 0 4.99979 0C5.26495 0 5.51926 0.105315 5.70679 0.292786L9.70679 4.29279C9.88894 4.48139 9.98974 4.73399 9.98746 4.99619C9.98518 5.25838 9.88001 5.5092 9.6946 5.6946C9.5092 5.88001 9.25838 5.98518 8.99619 5.98746C8.73399 5.98974 8.48139 5.88894 8.29279 5.70679L5.99979 3.41379V14.9998C5.99979 15.265 5.89443 15.5194 5.70689 15.7069C5.51936 15.8944 5.265 15.9998 4.99979 15.9998C4.73457 15.9998 4.48022 15.8944 4.29268 15.7069C4.10514 15.5194 3.99979 15.265 3.99979 14.9998V3.41379L1.70679 5.70679C1.51926 5.89426 1.26495 5.99957 0.999786 5.99957C0.734622 5.99957 0.480314 5.89426 0.292787 5.70679V5.70679Z"
                          fill={`${
                            props?.formData?.rollNo === 1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>

                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            rollNo: -1,
                            rollNoLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 11 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.71929 10.293C9.90676 10.4805 10.0121 10.7348 10.0121 11C10.0121 11.2652 9.90676 11.5195 9.71929 11.707L5.71929 15.707C5.53176 15.8945 5.27745 15.9998 5.01229 15.9998C4.74712 15.9998 4.49282 15.8945 4.30529 15.707L0.305288 11.707C0.209778 11.6148 0.133596 11.5044 0.0811869 11.3824C0.0287779 11.2604 0.00119157 11.1292 3.77571e-05 10.9964C-0.00111606 10.8636 0.0241854 10.7319 0.0744663 10.609C0.124747 10.4861 0.199 10.3745 0.292893 10.2806C0.386786 10.1867 0.498438 10.1125 0.621334 10.0622C0.74423 10.0119 0.87591 9.9866 1.00869 9.98775C1.14147 9.9889 1.27269 10.0165 1.39469 10.0689C1.5167 10.1213 1.62704 10.1975 1.71929 10.293L4.01229 12.586V1C4.01229 0.734784 4.11765 0.48043 4.30518 0.292893C4.49272 0.105357 4.74707 0 5.01229 0C5.2775 0 5.53186 0.105357 5.71939 0.292893C5.90693 0.48043 6.01229 0.734784 6.01229 1V12.586L8.30529 10.293C8.49282 10.1055 8.74712 10.0002 9.01229 10.0002C9.27745 10.0002 9.53176 10.1055 9.71929 10.293Z"
                          fill={`${
                            props?.formData?.rollNo === -1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>
                      {props?.formData?.rollNoLoader === true && (
                        <Spin indicator={antIcon} />
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="flex gap-2 items-center ">
                      <p className="text-[#6E7C87] text-[12px] md:text-[14px]">
                        {props?.table?.Name}
                      </p>
                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            fellowshipName: 1,
                            fellowshipNameLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 10 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.292787 5.70679C0.105316 5.51926 0 5.26495 0 4.99979C0 4.73462 0.105316 4.48031 0.292787 4.29279L4.29279 0.292786C4.48031 0.105315 4.73462 0 4.99979 0C5.26495 0 5.51926 0.105315 5.70679 0.292786L9.70679 4.29279C9.88894 4.48139 9.98974 4.73399 9.98746 4.99619C9.98518 5.25838 9.88001 5.5092 9.6946 5.6946C9.5092 5.88001 9.25838 5.98518 8.99619 5.98746C8.73399 5.98974 8.48139 5.88894 8.29279 5.70679L5.99979 3.41379V14.9998C5.99979 15.265 5.89443 15.5194 5.70689 15.7069C5.51936 15.8944 5.265 15.9998 4.99979 15.9998C4.73457 15.9998 4.48022 15.8944 4.29268 15.7069C4.10514 15.5194 3.99979 15.265 3.99979 14.9998V3.41379L1.70679 5.70679C1.51926 5.89426 1.26495 5.99957 0.999786 5.99957C0.734622 5.99957 0.480314 5.89426 0.292787 5.70679V5.70679Z"
                          fill={`${
                            props?.formData?.fellowshipName === 1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>

                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            fellowshipName: -1,
                            fellowshipNameLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 11 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.71929 10.293C9.90676 10.4805 10.0121 10.7348 10.0121 11C10.0121 11.2652 9.90676 11.5195 9.71929 11.707L5.71929 15.707C5.53176 15.8945 5.27745 15.9998 5.01229 15.9998C4.74712 15.9998 4.49282 15.8945 4.30529 15.707L0.305288 11.707C0.209778 11.6148 0.133596 11.5044 0.0811869 11.3824C0.0287779 11.2604 0.00119157 11.1292 3.77571e-05 10.9964C-0.00111606 10.8636 0.0241854 10.7319 0.0744663 10.609C0.124747 10.4861 0.199 10.3745 0.292893 10.2806C0.386786 10.1867 0.498438 10.1125 0.621334 10.0622C0.74423 10.0119 0.87591 9.9866 1.00869 9.98775C1.14147 9.9889 1.27269 10.0165 1.39469 10.0689C1.5167 10.1213 1.62704 10.1975 1.71929 10.293L4.01229 12.586V1C4.01229 0.734784 4.11765 0.48043 4.30518 0.292893C4.49272 0.105357 4.74707 0 5.01229 0C5.2775 0 5.53186 0.105357 5.71939 0.292893C5.90693 0.48043 6.01229 0.734784 6.01229 1V12.586L8.30529 10.293C8.49282 10.1055 8.74712 10.0002 9.01229 10.0002C9.27745 10.0002 9.53176 10.1055 9.71929 10.293Z"
                          fill={`${
                            props?.formData?.fellowshipName === -1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>
                      {props?.formData?.fellowshipNameLoader === true ? (
                        <Spin indicator={antIcon} />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  <td className="">
                    <div className="flex gap-2 items-center">
                      <p className="text-[#6E7C87] text-[12px] md:text-[14px]">
                        {props?.table?.Created_by}
                      </p>
                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            owner: 1,
                            ownerLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 10 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.292787 5.70679C0.105316 5.51926 0 5.26495 0 4.99979C0 4.73462 0.105316 4.48031 0.292787 4.29279L4.29279 0.292786C4.48031 0.105315 4.73462 0 4.99979 0C5.26495 0 5.51926 0.105315 5.70679 0.292786L9.70679 4.29279C9.88894 4.48139 9.98974 4.73399 9.98746 4.99619C9.98518 5.25838 9.88001 5.5092 9.6946 5.6946C9.5092 5.88001 9.25838 5.98518 8.99619 5.98746C8.73399 5.98974 8.48139 5.88894 8.29279 5.70679L5.99979 3.41379V14.9998C5.99979 15.265 5.89443 15.5194 5.70689 15.7069C5.51936 15.8944 5.265 15.9998 4.99979 15.9998C4.73457 15.9998 4.48022 15.8944 4.29268 15.7069C4.10514 15.5194 3.99979 15.265 3.99979 14.9998V3.41379L1.70679 5.70679C1.51926 5.89426 1.26495 5.99957 0.999786 5.99957C0.734622 5.99957 0.480314 5.89426 0.292787 5.70679V5.70679Z"
                          fill={`${
                            props?.formData?.owner === 1 ? "#8E98A8" : "#DBDBDB"
                          }`}
                        />
                      </svg>

                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            owner: -1,
                            ownerLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 11 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.71929 10.293C9.90676 10.4805 10.0121 10.7348 10.0121 11C10.0121 11.2652 9.90676 11.5195 9.71929 11.707L5.71929 15.707C5.53176 15.8945 5.27745 15.9998 5.01229 15.9998C4.74712 15.9998 4.49282 15.8945 4.30529 15.707L0.305288 11.707C0.209778 11.6148 0.133596 11.5044 0.0811869 11.3824C0.0287779 11.2604 0.00119157 11.1292 3.77571e-05 10.9964C-0.00111606 10.8636 0.0241854 10.7319 0.0744663 10.609C0.124747 10.4861 0.199 10.3745 0.292893 10.2806C0.386786 10.1867 0.498438 10.1125 0.621334 10.0622C0.74423 10.0119 0.87591 9.9866 1.00869 9.98775C1.14147 9.9889 1.27269 10.0165 1.39469 10.0689C1.5167 10.1213 1.62704 10.1975 1.71929 10.293L4.01229 12.586V1C4.01229 0.734784 4.11765 0.48043 4.30518 0.292893C4.49272 0.105357 4.74707 0 5.01229 0C5.2775 0 5.53186 0.105357 5.71939 0.292893C5.90693 0.48043 6.01229 0.734784 6.01229 1V12.586L8.30529 10.293C8.49282 10.1055 8.74712 10.0002 9.01229 10.0002C9.27745 10.0002 9.53176 10.1055 9.71929 10.293Z"
                          fill={`${
                            props?.formData?.owner === -1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>
                      {props?.formData?.ownerLoader === true ? (
                        <Spin indicator={antIcon} />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  <td className="">
                    <div className="flex gap-2 items-center">
                      <p className="text-[#6E7C87] text-[12px]  md:text-[14px]">
                        {props?.table?.Phone}
                        {props?.table?.TimeRequested}
                      </p>
                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            phone: 1,
                            phoneLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 10 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.292787 5.70679C0.105316 5.51926 0 5.26495 0 4.99979C0 4.73462 0.105316 4.48031 0.292787 4.29279L4.29279 0.292786C4.48031 0.105315 4.73462 0 4.99979 0C5.26495 0 5.51926 0.105315 5.70679 0.292786L9.70679 4.29279C9.88894 4.48139 9.98974 4.73399 9.98746 4.99619C9.98518 5.25838 9.88001 5.5092 9.6946 5.6946C9.5092 5.88001 9.25838 5.98518 8.99619 5.98746C8.73399 5.98974 8.48139 5.88894 8.29279 5.70679L5.99979 3.41379V14.9998C5.99979 15.265 5.89443 15.5194 5.70689 15.7069C5.51936 15.8944 5.265 15.9998 4.99979 15.9998C4.73457 15.9998 4.48022 15.8944 4.29268 15.7069C4.10514 15.5194 3.99979 15.265 3.99979 14.9998V3.41379L1.70679 5.70679C1.51926 5.89426 1.26495 5.99957 0.999786 5.99957C0.734622 5.99957 0.480314 5.89426 0.292787 5.70679V5.70679Z"
                          fill={`${
                            props?.formData?.phone === 1 ? "#8E98A8" : "#DBDBDB"
                          }`}
                        />
                      </svg>
                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            phone: -1,
                            phoneLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 11 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.71929 10.293C9.90676 10.4805 10.0121 10.7348 10.0121 11C10.0121 11.2652 9.90676 11.5195 9.71929 11.707L5.71929 15.707C5.53176 15.8945 5.27745 15.9998 5.01229 15.9998C4.74712 15.9998 4.49282 15.8945 4.30529 15.707L0.305288 11.707C0.209778 11.6148 0.133596 11.5044 0.0811869 11.3824C0.0287779 11.2604 0.00119157 11.1292 3.77571e-05 10.9964C-0.00111606 10.8636 0.0241854 10.7319 0.0744663 10.609C0.124747 10.4861 0.199 10.3745 0.292893 10.2806C0.386786 10.1867 0.498438 10.1125 0.621334 10.0622C0.74423 10.0119 0.87591 9.9866 1.00869 9.98775C1.14147 9.9889 1.27269 10.0165 1.39469 10.0689C1.5167 10.1213 1.62704 10.1975 1.71929 10.293L4.01229 12.586V1C4.01229 0.734784 4.11765 0.48043 4.30518 0.292893C4.49272 0.105357 4.74707 0 5.01229 0C5.2775 0 5.53186 0.105357 5.71939 0.292893C5.90693 0.48043 6.01229 0.734784 6.01229 1V12.586L8.30529 10.293C8.49282 10.1055 8.74712 10.0002 9.01229 10.0002C9.27745 10.0002 9.53176 10.1055 9.71929 10.293Z"
                          fill={`${
                            props?.formData?.phone === -1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>
                      {props?.formData?.phoneLoader === true ? (
                        <Spin indicator={antIcon} />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>

                  <td>
                    <div className={`${props?.hidden} flex gap-2 items-center`}>
                      <p className="text-[#6E7C87] text-[12px] md:text-[14px]">
                        {props?.table?.progress}
                      </p>
                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            campusDataEntryProgressPlain: 1,
                            campusDataEntryProgressPlainLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 10 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.292787 5.70679C0.105316 5.51926 0 5.26495 0 4.99979C0 4.73462 0.105316 4.48031 0.292787 4.29279L4.29279 0.292786C4.48031 0.105315 4.73462 0 4.99979 0C5.26495 0 5.51926 0.105315 5.70679 0.292786L9.70679 4.29279C9.88894 4.48139 9.98974 4.73399 9.98746 4.99619C9.98518 5.25838 9.88001 5.5092 9.6946 5.6946C9.5092 5.88001 9.25838 5.98518 8.99619 5.98746C8.73399 5.98974 8.48139 5.88894 8.29279 5.70679L5.99979 3.41379V14.9998C5.99979 15.265 5.89443 15.5194 5.70689 15.7069C5.51936 15.8944 5.265 15.9998 4.99979 15.9998C4.73457 15.9998 4.48022 15.8944 4.29268 15.7069C4.10514 15.5194 3.99979 15.265 3.99979 14.9998V3.41379L1.70679 5.70679C1.51926 5.89426 1.26495 5.99957 0.999786 5.99957C0.734622 5.99957 0.480314 5.89426 0.292787 5.70679V5.70679Z"
                          fill={`${
                            props?.formData?.campusDataEntryProgressPlain === 1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>

                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            campusDataEntryProgressPlain: -1,
                            campusDataEntryProgressPlainLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 11 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.71929 10.293C9.90676 10.4805 10.0121 10.7348 10.0121 11C10.0121 11.2652 9.90676 11.5195 9.71929 11.707L5.71929 15.707C5.53176 15.8945 5.27745 15.9998 5.01229 15.9998C4.74712 15.9998 4.49282 15.8945 4.30529 15.707L0.305288 11.707C0.209778 11.6148 0.133596 11.5044 0.0811869 11.3824C0.0287779 11.2604 0.00119157 11.1292 3.77571e-05 10.9964C-0.00111606 10.8636 0.0241854 10.7319 0.0744663 10.609C0.124747 10.4861 0.199 10.3745 0.292893 10.2806C0.386786 10.1867 0.498438 10.1125 0.621334 10.0622C0.74423 10.0119 0.87591 9.9866 1.00869 9.98775C1.14147 9.9889 1.27269 10.0165 1.39469 10.0689C1.5167 10.1213 1.62704 10.1975 1.71929 10.293L4.01229 12.586V1C4.01229 0.734784 4.11765 0.48043 4.30518 0.292893C4.49272 0.105357 4.74707 0 5.01229 0C5.2775 0 5.53186 0.105357 5.71939 0.292893C5.90693 0.48043 6.01229 0.734784 6.01229 1V12.586L8.30529 10.293C8.49282 10.1055 8.74712 10.0002 9.01229 10.0002C9.27745 10.0002 9.53176 10.1055 9.71929 10.293Z"
                          fill={`${
                            props?.formData?.campusDataEntryProgressPlain === -1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>
                      {props?.formData?.campusDataEntryProgressPlainLoader ===
                      true ? (
                        <Spin indicator={antIcon} />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  <td>
                    <div
                      className={`${props?.hidden} flex gap-2 items-center `}
                    >
                      <p className="text-[#6E7C87] text-[12px] md:text-[14px]">
                        {props?.table?.Log}
                      </p>
                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            campusLog: 1,
                            campusLogLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 10 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.292787 5.70679C0.105316 5.51926 0 5.26495 0 4.99979C0 4.73462 0.105316 4.48031 0.292787 4.29279L4.29279 0.292786C4.48031 0.105315 4.73462 0 4.99979 0C5.26495 0 5.51926 0.105315 5.70679 0.292786L9.70679 4.29279C9.88894 4.48139 9.98974 4.73399 9.98746 4.99619C9.98518 5.25838 9.88001 5.5092 9.6946 5.6946C9.5092 5.88001 9.25838 5.98518 8.99619 5.98746C8.73399 5.98974 8.48139 5.88894 8.29279 5.70679L5.99979 3.41379V14.9998C5.99979 15.265 5.89443 15.5194 5.70689 15.7069C5.51936 15.8944 5.265 15.9998 4.99979 15.9998C4.73457 15.9998 4.48022 15.8944 4.29268 15.7069C4.10514 15.5194 3.99979 15.265 3.99979 14.9998V3.41379L1.70679 5.70679C1.51926 5.89426 1.26495 5.99957 0.999786 5.99957C0.734622 5.99957 0.480314 5.89426 0.292787 5.70679V5.70679Z"
                          fill={`${
                            props?.formData?.campusLog === 1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>

                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            campusLog: -1,
                            campusLogLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 11 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.71929 10.293C9.90676 10.4805 10.0121 10.7348 10.0121 11C10.0121 11.2652 9.90676 11.5195 9.71929 11.707L5.71929 15.707C5.53176 15.8945 5.27745 15.9998 5.01229 15.9998C4.74712 15.9998 4.49282 15.8945 4.30529 15.707L0.305288 11.707C0.209778 11.6148 0.133596 11.5044 0.0811869 11.3824C0.0287779 11.2604 0.00119157 11.1292 3.77571e-05 10.9964C-0.00111606 10.8636 0.0241854 10.7319 0.0744663 10.609C0.124747 10.4861 0.199 10.3745 0.292893 10.2806C0.386786 10.1867 0.498438 10.1125 0.621334 10.0622C0.74423 10.0119 0.87591 9.9866 1.00869 9.98775C1.14147 9.9889 1.27269 10.0165 1.39469 10.0689C1.5167 10.1213 1.62704 10.1975 1.71929 10.293L4.01229 12.586V1C4.01229 0.734784 4.11765 0.48043 4.30518 0.292893C4.49272 0.105357 4.74707 0 5.01229 0C5.2775 0 5.53186 0.105357 5.71939 0.292893C5.90693 0.48043 6.01229 0.734784 6.01229 1V12.586L8.30529 10.293C8.49282 10.1055 8.74712 10.0002 9.01229 10.0002C9.27745 10.0002 9.53176 10.1055 9.71929 10.293Z"
                          fill={`${
                            props?.formData.campusLog === -1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>
                      {props?.formData?.campusLogLoader === true ? (
                        <Spin indicator={antIcon} />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  <td>
                    <div
                      className={`${props?.hidden} flex gap-2 items-center `}
                    >
                      <p className="text-[#6E7C87] text-[12px] md:text-[14px]">
                        {props?.table?.Statues}
                      </p>
                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            campusStatus: 1,
                            campusStatusLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 10 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.292787 5.70679C0.105316 5.51926 0 5.26495 0 4.99979C0 4.73462 0.105316 4.48031 0.292787 4.29279L4.29279 0.292786C4.48031 0.105315 4.73462 0 4.99979 0C5.26495 0 5.51926 0.105315 5.70679 0.292786L9.70679 4.29279C9.88894 4.48139 9.98974 4.73399 9.98746 4.99619C9.98518 5.25838 9.88001 5.5092 9.6946 5.6946C9.5092 5.88001 9.25838 5.98518 8.99619 5.98746C8.73399 5.98974 8.48139 5.88894 8.29279 5.70679L5.99979 3.41379V14.9998C5.99979 15.265 5.89443 15.5194 5.70689 15.7069C5.51936 15.8944 5.265 15.9998 4.99979 15.9998C4.73457 15.9998 4.48022 15.8944 4.29268 15.7069C4.10514 15.5194 3.99979 15.265 3.99979 14.9998V3.41379L1.70679 5.70679C1.51926 5.89426 1.26495 5.99957 0.999786 5.99957C0.734622 5.99957 0.480314 5.89426 0.292787 5.70679V5.70679Z"
                          fill={`${
                            props?.formData?.campusStatus === 1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>

                      <svg
                        onClick={() =>
                          props?.SetAllcampusformData({
                            ...props?.formData,
                            campusStatus: -1,
                            campusStatusLoader: true,
                          })
                        }
                        width="8"
                        height="10"
                        viewBox="0 0 11 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.71929 10.293C9.90676 10.4805 10.0121 10.7348 10.0121 11C10.0121 11.2652 9.90676 11.5195 9.71929 11.707L5.71929 15.707C5.53176 15.8945 5.27745 15.9998 5.01229 15.9998C4.74712 15.9998 4.49282 15.8945 4.30529 15.707L0.305288 11.707C0.209778 11.6148 0.133596 11.5044 0.0811869 11.3824C0.0287779 11.2604 0.00119157 11.1292 3.77571e-05 10.9964C-0.00111606 10.8636 0.0241854 10.7319 0.0744663 10.609C0.124747 10.4861 0.199 10.3745 0.292893 10.2806C0.386786 10.1867 0.498438 10.1125 0.621334 10.0622C0.74423 10.0119 0.87591 9.9866 1.00869 9.98775C1.14147 9.9889 1.27269 10.0165 1.39469 10.0689C1.5167 10.1213 1.62704 10.1975 1.71929 10.293L4.01229 12.586V1C4.01229 0.734784 4.11765 0.48043 4.30518 0.292893C4.49272 0.105357 4.74707 0 5.01229 0C5.2775 0 5.53186 0.105357 5.71939 0.292893C5.90693 0.48043 6.01229 0.734784 6.01229 1V12.586L8.30529 10.293C8.49282 10.1055 8.74712 10.0002 9.01229 10.0002C9.27745 10.0002 9.53176 10.1055 9.71929 10.293Z"
                          fill={`${
                            props.formData.campusStatus === -1
                              ? "#8E98A8"
                              : "#DBDBDB"
                          }`}
                        />
                      </svg>
                      {props?.formData?.campusStatusLoader === true ? (
                        <Spin indicator={antIcon} />
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  <td className="hidden md:block"></td>
                </tr>
              </thead>
              {props.invited?.map((data, index) => (
                <>
                  <tbody
                    key={index}
                    className={`${
                      data?.campusDataEntryProgressPlain === 11
                        ? "bg-[#EBFFF1]"
                        : data?.campusDataEntryProgressPlain === 1
                        ? ""
                        : data?.campusDataEntryProgressPlain < 5
                        ? "bgs-[#ebebff]"
                        : "bg-[#f3ff9ca8]"
                    } border border-solide h-[40px] hover:bg-gray-100 dark:hover:text-black`}
                  >
                    <tr className="">
                      <td className="pl-2  ">{data?.rollNo}</td>
                      <td className="text-[12px] md:text-md text-ellipsis overflow-hidden lg:max-w-[5%] py-1 ">
                        <p>{data?.fellowshipName}</p>
                      </td>
                      <td className="text-[12px] md:text-md text-ellipsis overflow-hidden lg:max-w-[400px] ">
                        <p>
                          {data?.owner}
                          {data?.requestedBy}
                        </p>
                      </td>
                      <td className="text-[12px]  md:text-md text-ellipsis overflow-hidden ">
                        <p className="">
                          {data?.phone} {data?.timeRequested}
                        </p>
                      </td>
                      <td className="text-[12px] md:text-md text-ellipsis overflow-hidden ">
                        <p className="  rounded-sm py-1 text-[12px] md:text-md ">
                          {data?.campusDataEntryProgress}
                        </p>
                      </td>
                      <td className="text-[12px] md:text-md text-ellipsis overflow-hidden ">
                        <p>{data?.campusLog}</p>
                      </td>
                      <td className={`${props?.hidden}`}>
                        <p
                          className={` rounded-[6px] text-[12px] md:text-[12px] px-2 py-1 text-center text-ellipsis overflow-hidden   ${
                            data?.campusStatus === "in Trash"
                              ? " text-[#CC0905] bg-[#FFEFEB]"
                              : data?.campusStatus === "Unpublished"
                              ? "text-yellow-600 bg-[#f3ff9ca8]"
                              : "text-[#119C2B] bg-[#EBFFF1] "
                          }`}
                        >
                          {data?.campusStatus}
                        </p>
                      </td>
                      <td className="flex justify-center items-center">
                        <Dropdown
                          overlay={() => menu(data?.id, data?.campusStatus)}
                          trigger={["click"]}
                        >
                          <a
                            key={data.id}
                            className="ant-dropdown-link"
                            //onClick={() => menuAction(data.id,data.isPublished)}
                            style={{ color: "#d46b08", fontWeight: "bold" }}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8 12C8 12.5304 7.78929 13.0391 7.41421 13.4142C7.03914 13.7893 6.53043 14 6 14C5.46957 14 4.96086 13.7893 4.58579 13.4142C4.21071 13.0391 4 12.5304 4 12C4 11.4696 4.21071 10.9609 4.58579 10.5858C4.96086 10.2107 5.46957 10 6 10C6.53043 10 7.03914 10.2107 7.41421 10.5858C7.78929 10.9609 8 11.4696 8 12ZM14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12ZM18 14C18.5304 14 19.0391 13.7893 19.4142 13.4142C19.7893 13.0391 20 12.5304 20 12C20 11.4696 19.7893 10.9609 19.4142 10.5858C19.0391 10.2107 18.5304 10 18 10C17.4696 10 16.9609 10.2107 16.5858 10.5858C16.2107 10.9609 16 11.4696 16 12C16 12.5304 16.2107 13.0391 16.5858 13.4142C16.9609 13.7893 17.4696 14 18 14Z"
                                fill="#5B6871"
                              />
                            </svg>
                          </a>
                        </Dropdown>
                      </td>
                    </tr>
                  </tbody>
                </>
              ))}
            </table>
          ) : (
            <div className="m-2 mb-8">
              <Empty />
            </div>
          )}
        </div>

        <div className="flex  justify-center items-center gap-5 p-5 w-full ">
          <PaginatedItems
            pageinationComponents={props?.pageinationComponent}
            formData={props?.formData}
            pageCount={Math.ceil(props?.pageCount)}
            resultsPerPage={props?.resultsPerPage}
            itemsPerPage={props?.itemsPerPage}
            items={props?.invited}
            setItemOffset={props?.SetAllcampusformData}
          />
          <RowSelect
            rowsPerPage={props?.resultsPerPage}
            onChange={(value) =>
              handleRowsPerPageChange(value, props?.itemsPerPage)
            }
          />
        </div>
      </div>
    </div>
  );
}

export default Table;
